// router.tsx
import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route,
} from "react-router-dom";
import HomePage from "./pages/index";
import ChatPage from "./pages/ChatPage";
import ChatDashboard from "./pages/ChatDashboard";
import ThemeControl from "./components/flowbite-wrapper";
import AgentListPage from "./pages/agentList";
import AgentManagementList from "./pages/agents/AgentList";
import AgentDetails from "./pages/agents/AgentDetails";
import ForgotPasswordPage from "./pages/authentication/forgot-password";
import ProfileLockPage from "./pages/authentication/profile-lock";
import ResetPasswordPage from "./pages/authentication/reset-password";
import SignInPage from "./pages/authentication/sign-in";
import SignUpPage from "./pages/sign-up";
import UserProfilePage from "./pages/profile";
import UserSettingsPage from "./pages/settings";
import TicketDashboard from "./pages/ticketList/TicketList";
import LoginPage from "./pages/LoginPage";
import AuthGuide from "./components/AuthGuide";
import RequestList from "./pages/RequestList";
import TicketDetails from "./pages/ticketDetails/TicketDetails";
import CategoryList from "./pages/categoryList/CategoryList";
import GroupList from "./pages/groups/GroupList";
import GroupDetails from "./pages/groups/GroupDetails";
import ClientList from "./pages/clients/ClientList";
import SubcategoryList from "./pages/subcategories/SubcategoryList";
import SubcategoryDetails from "./pages/subcategories/SubcategoryDetails";
import WorkShiftList from "./pages/workShifts/WorkShiftList";
import WorkShiftDetails from "./pages/workShifts/WorkShiftDetails";
import ClientGroupList from "./pages/clientGroups/ClientGroupList";
import ClientGroupDetails from "./pages/clientGroups/ClientGroupDetails";
import ReportsPage from "./pages/reports/ReportsPage";
import UpdateReasonList from "./pages/updateReasons/UpdateReasonList";
import ClientConversationAnalysis from "./pages/reports/ClientConversationAnalysis";
import ChannelDistributionReport from "./pages/reports/ChannelDistributionReport";
import KnowledgeBasePage from "./pages/knowledgeBase/KnowledgeBasePage";
import CompanySettingsPage from "./pages/companySettings/CompanySettingsPage";
import CreateCompanyPage from "./pages/companySettings/CreateCompanyPage";
import AdminHomeDashboard from "./pages/AdminHomeDashboard";
import CompanyList from "./pages/companies/CompanyList";
import HomeRoute from "./pages/HomeRoute";
import TextToSpeechPage from "./pages/textToSpeech/TextToSpeechPage";


export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      <Route element={<AuthGuide />}>
        <Route element={<ThemeControl />}>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<HomeRoute />} index /> {/* Admin: stats dashboard, Agent: chat dashboard */}
          <Route path="/home" element={<HomePage />} /> {/* Old home page moved to /home */}
          <Route path="/dashboard" element={<AdminHomeDashboard />} /> {/* Admin stats dashboard */}
          <Route path="/chat" element={<ChatPage />} /> {/* New prop-based route */}
          <Route path="/authentication/sign-in" element={<SignInPage />} />
          <Route path="/requestList" element={<RequestList />} />
          <Route path="/signup" element={<SignUpPage />} />
          <Route
            path="/authentication/forgot-password"
            element={<ForgotPasswordPage />}
          />
          <Route
            path="/authentication/reset-password"
            element={<ResetPasswordPage />}
          />
          <Route
            path="/authentication/profile-lock"
            element={<ProfileLockPage />}
          />
          <Route path="/tickets" element={<TicketDashboard />} />
          <Route path="/categories" element={<CategoryList />} />
          <Route path="/groups" element={<GroupList />} />
          <Route path="/groups/:id" element={<GroupDetails />} />
          <Route path="/clients" element={<ClientList />} />
          <Route path="/client-groups" element={<ClientGroupList />} />
          <Route path="/client-groups/:id" element={<ClientGroupDetails />} />
          <Route path="/subcategories" element={<SubcategoryList />} />
          <Route path="/subcategories/:id" element={<SubcategoryDetails />} />

          <Route path="/tickets/:ticketId" element={<TicketDetails />} />
          <Route path="/settings" element={<UserSettingsPage />} />
          <Route path="/profile" element={<UserProfilePage />} />
          <Route path="/agentList" element={<AgentListPage />} />
          <Route path="/agents" element={<AgentManagementList />} />
          <Route path="/agents/:id" element={<AgentDetails />} />
          <Route path="/agents/profile" element={<UserProfilePage />} />
          <Route path="/agents/settings" element={<UserSettingsPage />} />
          <Route path="/work-shifts" element={<WorkShiftList />} />
          <Route path="/work-shifts/:id" element={<WorkShiftDetails />} />
          <Route path="/update-reasons" element={<UpdateReasonList />} />
          <Route path="/knowledge-base" element={<KnowledgeBasePage />} />
          <Route path="/reports" element={<ReportsPage />} />
          <Route path="/reports/client-conversations" element={<ClientConversationAnalysis />} />
          <Route path="/reports/channel-distribution" element={<ChannelDistributionReport />} />
          <Route path="/companies" element={<CompanyList />} /> {/* Super admin: all companies */}
          <Route path="/company-settings" element={<CompanySettingsPage />} />
          <Route path="/company-settings/create" element={<CreateCompanyPage />} />
          <Route path="/text-to-speech" element={<TextToSpeechPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Route>
    </Route>,
  ),
);
